import * as React from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { Dialog } from "@mui/material";
import { PrinterDialog } from "./printer-dialog";
import { PositionPrinterDialog } from "./position-printer-dialog";

const columns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "position",
    headerName: "Posição",
    width: 80,
  },
  {
    field: "code",
    headerName: "Código",
    width: 500,
  },
];

export type PositionTableRow = {
  id: string;
  position: string;
  code: string;
};

type Props = {
  data: PositionTableRow[];
};

export default function PositionsTable({ data }: Props) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [code, setCode] = React.useState<string>("");
  const [position, setPosition] = React.useState<string>("");
  return (
    <div style={{ width: "100%" }}>
      <PositionPrinterDialog
        open={dialogOpen}
        setIsOpen={setDialogOpen}
        code={code}
        position={position}
      />
      <DataGrid
        rows={data}
        columns={columns}
        slots={{
          toolbar: GridToolbar,
        }}
        onRowDoubleClick={(row) => {
          setCode(row.row.code);
          setPosition(row.row.position);
          setDialogOpen(true);
        }}
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
      />
    </div>
  );
}
